export default __webpack_public_path__ + "static/media/slot_frame.26dbd302.png";